import { ConfiguratorOptions } from '../types/ConfiguratorOptions';

// separate file so idearoom app can import without importing all of SDK.
export const DefaultSdkConfiguratorOptions: ConfiguratorOptions = {
  header: true,
  menuSaveButtons: true,
  verbose: false,
};
